var _g, _g2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCards2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 20,
    viewBox: "0 0 140 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_846_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8734 16.977H15.3452L17.552 3.05237H21.08L18.8734 16.977Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6632 3.39282C30.9673 3.11107 29.8635 2.79999 28.4987 2.79999C25.0145 2.79999 22.5609 4.69601 22.5459 7.40676C22.517 9.40674 24.3026 10.5176 25.6381 11.1844C27.0031 11.8659 27.4671 12.3106 27.4671 12.918C27.4532 13.8509 26.3641 14.2809 25.3483 14.2809C23.9397 14.2809 23.1849 14.0592 22.0379 13.5402L21.5733 13.3177L21.0796 16.4435C21.9071 16.8282 23.4317 17.1696 25.0145 17.1846C28.7165 17.1846 31.1267 15.3179 31.1552 12.4292C31.1693 10.844 30.2264 9.62942 28.1937 8.63691C26.9597 7.99978 26.2039 7.57018 26.2039 6.91828C26.2184 6.32565 26.8431 5.71865 28.2361 5.71865C29.3831 5.68892 30.2259 5.97027 30.8643 6.25182L31.1834 6.39968L31.6632 3.39282V3.39282Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3521 12.044C36.6426 11.2441 37.7606 8.148 37.7606 8.148C37.746 8.17773 38.0506 7.33329 38.2248 6.81488L38.4714 8.01471C38.4714 8.01471 39.1395 11.3478 39.2846 12.044C38.7332 12.044 37.0489 12.044 36.3521 12.044ZM40.707 3.05237H37.9781C37.1365 3.05237 36.4971 3.30399 36.1341 4.2077L30.8936 16.9768H34.5955C34.5955 16.9768 35.2049 15.2582 35.3359 14.888C35.742 14.888 39.3432 14.888 39.8657 14.888C39.967 15.3769 40.2866 16.9768 40.2866 16.9768H43.5533L40.707 3.05237V3.05237Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3982 3.05237L8.94298 12.5477L8.56541 10.6219C7.92661 8.39983 5.9232 5.9856 3.6875 4.78518L6.85236 16.9623H10.5833L16.1289 3.05237H12.3982V3.05237Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73453 3.05237H0.0580724L0 3.33372C4.42799 4.48925 7.36056 7.27462 8.56543 10.6225L7.33143 4.22286C7.12827 3.33352 6.50395 3.0817 5.73453 3.05237Z",
    fill: "#FAA61A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_846_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3999 2.13885H60.8257V17.8611H69.3999V2.13885Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3701 10C61.3701 6.80555 62.84 3.97222 65.0992 2.13889C63.4388 0.805559 61.3429 0 59.0565 0C53.6397 0 49.2573 4.47222 49.2573 10C49.2573 15.5278 53.6397 20 59.0565 20C61.3429 20 63.4388 19.1944 65.0992 17.8611C62.84 16.0556 61.3701 13.1944 61.3701 10Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9684 9.99989C80.9684 15.5277 76.586 19.9999 71.1693 19.9999C68.8828 19.9999 66.7869 19.1943 65.1265 17.861C67.4129 16.0277 68.8556 13.1943 68.8556 9.99989C68.8556 6.80544 67.3857 3.97211 65.1265 2.13877C66.7869 0.805438 68.8828 -0.00012207 71.1693 -0.00012207C76.586 -0.00012207 80.9684 4.49988 80.9684 9.99989Z",
    fill: "#F79E1B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6268 3.03948C94.0833 3.03669 95.4401 2.91199 96.0148 4.89137C96.4019 6.2247 97.0186 8.40876 97.8648 11.4436H98.2094C99.1169 8.24406 99.7403 6.06 100.08 4.89137C100.66 2.89137 102.112 3.03951 102.693 3.03951L107.173 3.03952V17.2617H102.607V8.88033H102.3L99.7549 17.2617H96.3193L93.7739 8.87412H93.4677V17.2617H88.9014V3.03952L93.6268 3.03948ZM113.73 3.03952V11.4271H114.094L117.191 4.53006C117.792 3.15752 119.073 3.03952 119.073 3.03952H123.492V17.2617H118.83V8.87412H118.466L115.43 15.7712C114.829 17.1375 113.487 17.2617 113.487 17.2617H109.068V3.03952H113.73ZM139.604 9.79801C138.954 11.6784 136.912 13.0252 134.651 13.0252H129.763V17.2617H125.33V9.79801H139.604Z",
    fill: "#0F754E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.863 3.03949H125.095C125.327 6.20584 127.999 8.91644 130.765 8.91644H139.91C140.438 6.28483 138.621 3.03949 134.863 3.03949Z",
    fill: "url(#paint0_linear_846_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_846_34",
    x1: 140,
    y1: 6.73634,
    x2: 125.095,
    y2: 6.73634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_846_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5537,
    height: 14.3846,
    fill: "white",
    transform: "translate(0 2.79999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_846_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7111,
    height: 20,
    fill: "white",
    transform: "translate(49.2573)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards2);
export default __webpack_public_path__ + "static/media/cards2.b9c2acffa3ac278d6709d63f77b26a94.svg";
export { ForwardRef as ReactComponent };